const isStaging = process.env.GATSBY_SANITY_BUILD_DRAFTS;
const isSSR = typeof window === 'undefined' || !window.document;

module.exports = { isStaging, isSSR };
